var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 200,
    viewBox: "0 0 300 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.86 117.299L225.543 119.029C222.835 133.623 212.842 145.323 199.294 149.04C197.55 149.521 195.77 149.862 193.972 150.059C180.98 151.507 167.132 145.469 158.476 134.574C153.386 128.168 149.744 120.022 142.888 115.92C133.958 110.575 123.169 114.07 113.871 117.65C104.564 121.239 93.7663 124.699 84.8536 119.312C79.275 115.946 75.6756 109.642 73.7903 103.184C68.777 86.097 74.553 67.2544 85.942 54.921C97.3313 42.5874 113.571 36.1894 130.033 34.1424C153.086 31.2817 177.887 36.8147 196.946 52.0604C216.005 67.3057 228.336 92.8204 225.86 117.299V117.299Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4165 99.8537C76.1685 91.906 72.7672 82.4213 64.8195 78.6693C56.8718 74.9177 47.3872 78.319 43.6352 86.2667C39.8835 94.2143 43.2848 103.699 51.2325 107.451C59.1802 111.203 68.6645 107.801 72.4165 99.8537Z",
    fill: "#A9162A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6641 97.4573C71.6768 98.009 72.2671 98.3533 72.7534 98.0923L78.9458 94.77C79.4684 94.4897 79.4648 93.7387 78.9391 93.4633L72.5968 90.141C72.0978 89.8797 71.5014 90.2497 71.5141 90.8127L71.6641 97.4573V97.4573Z",
    fill: "#A9162A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3987 93.4733C52.3938 93.7535 52.3336 94.0299 52.2218 94.2869C52.1099 94.5438 51.9484 94.7761 51.7467 94.9706C51.5449 95.165 51.3068 95.3178 51.0459 95.4201C50.785 95.5225 50.5066 95.5724 50.2264 95.567C49.9462 95.562 49.6698 95.5019 49.4128 95.39C49.1559 95.2781 48.9236 95.1167 48.7291 94.9149C48.5347 94.7132 48.3819 94.475 48.2796 94.2142C48.1772 93.9533 48.1273 93.6748 48.1327 93.3946C48.1377 93.1145 48.1979 92.8381 48.3098 92.5812C48.4217 92.3243 48.5831 92.092 48.7849 91.8975C48.9866 91.7031 49.2247 91.5503 49.4856 91.4479C49.7464 91.3456 50.0249 91.2956 50.3051 91.301C50.8706 91.3118 51.4088 91.5466 51.8014 91.9539C52.194 92.3612 52.4088 92.9077 52.3987 93.4733ZM59.8094 93.7876C59.6894 94.9586 58.6384 95.811 57.4674 95.691C56.2964 95.571 55.4441 94.52 55.5641 93.3493C55.6841 92.1783 56.7351 91.326 57.9061 91.446C59.0771 91.57 59.9294 92.6166 59.8094 93.7876ZM66.7771 93.916C66.6571 95.087 65.6061 95.9393 64.4351 95.8193C63.2641 95.6993 62.4117 94.6483 62.5317 93.4773C62.6517 92.3063 63.7027 91.454 64.8737 91.574C65.1525 91.6027 65.4229 91.6861 65.6695 91.8193C65.916 91.9526 66.1339 92.1331 66.3106 92.3506C66.4874 92.5681 66.6196 92.8183 66.6996 93.0869C66.7796 93.3555 66.8059 93.6372 66.7771 93.916Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7515 95.3033V155.57C91.7515 162.733 97.5531 168.535 104.716 168.535H195.463C202.626 168.535 208.428 162.733 208.428 155.57V95.3033",
    fill: "#A9162A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7515 95.3033V155.57C91.7515 162.733 97.5531 168.535 104.716 168.535H195.463C202.626 168.535 208.428 162.733 208.428 155.57V95.3033",
    stroke: "#A9162A",
    strokeWidth: 8.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4953 84.5487L142.833 54.0493C144.978 52.6073 147.505 51.8371 150.09 51.8371C152.675 51.8371 155.201 52.6073 157.347 54.0493L202.685 84.5487C210.321 89.6893 210.321 100.923 202.685 106.064L164.607 131.682C155.83 137.588 144.356 137.588 135.579 131.682L97.5016 106.064C89.8589 100.923 89.8589 89.6827 97.4953 84.5487V84.5487Z",
    fill: "white",
    stroke: "#A9162A",
    strokeWidth: 8.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.988 105.157H167.378M128.163 87.759H172.022H128.163Z",
    stroke: "#A9162A",
    strokeWidth: 8.13533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232.429 143.209L221.175 154.462C220.766 154.872 220.766 155.536 221.175 155.946C221.585 156.356 222.25 156.356 222.659 155.946L233.913 144.693C234.322 144.283 234.322 143.618 233.913 143.209C233.503 142.799 232.839 142.799 232.429 143.209Z",
    fill: "#E1E4E5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M231.327 151.266L228.082 154.511C227.672 154.921 227.672 155.585 228.082 155.995C228.492 156.405 229.156 156.405 229.566 155.995L232.811 152.75C233.221 152.34 233.221 151.676 232.811 151.266C232.402 150.856 231.737 150.856 231.327 151.266Z",
    fill: "#E1E4E5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M168.456 40.5541L179.709 29.3007C180.119 28.8909 180.119 28.2265 179.709 27.8167C179.299 27.4069 178.635 27.4069 178.225 27.8167L166.972 39.0701C166.562 39.4799 166.562 40.1443 166.972 40.5541C167.382 40.9639 168.046 40.9639 168.456 40.5541Z",
    fill: "#E1E4E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.557 32.4967L172.802 29.2513C173.212 28.8415 173.212 28.1771 172.802 27.7673C172.392 27.3576 171.728 27.3576 171.318 27.7674L168.073 31.0127C167.663 31.4225 167.663 32.0869 168.073 32.4967C168.483 32.9065 169.147 32.9065 169.557 32.4967Z",
    fill: "#E1E4E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6599 133.547L66.7116 143.496C66.3493 143.858 66.3494 144.445 66.7116 144.808C67.0739 145.17 67.6613 145.17 68.0235 144.808L77.9718 134.859C78.3341 134.497 78.3341 133.91 77.9718 133.547C77.6096 133.185 77.0222 133.185 76.6599 133.547Z",
    fill: "#E1E4E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6858 140.67L72.8168 143.539C72.4546 143.902 72.4546 144.489 72.8168 144.851C73.1791 145.214 73.7665 145.214 74.1288 144.851L76.9977 141.982C77.36 141.62 77.36 141.033 76.9977 140.67C76.6355 140.308 76.0481 140.308 75.6858 140.67Z",
    fill: "#E1E4E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M229.72 77.9224L239.016 68.6265C239.354 68.288 239.354 67.7393 239.016 67.4008L239.015 67.4006C238.677 67.0622 238.128 67.0621 237.79 67.4006L228.494 76.6965C228.155 77.0349 228.155 77.5837 228.494 77.9221L228.494 77.9224C228.833 78.2608 229.381 78.2608 229.72 77.9224Z",
    fill: "#E1E4E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M230.629 71.2666L233.311 68.5855C233.649 68.247 233.649 67.6983 233.311 67.3598L233.31 67.3596C232.972 67.0211 232.423 67.0211 232.085 67.3596L229.404 70.0407C229.065 70.3792 229.065 70.9279 229.404 71.2663L229.404 71.2666C229.742 71.605 230.291 71.605 230.629 71.2666Z",
    fill: "#E1E4E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M242.261 125.41L238.378 121.712L242.261 118.014L246.144 121.712L242.261 125.41Z",
    stroke: "#E1E4E5",
    strokeWidth: 1.881,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5348 124.017C67.5348 126.06 65.8788 127.715 63.8328 127.715C61.7872 127.715 60.1392 126.052 60.1392 124.017C60.1392 121.973 61.7952 120.319 63.8412 120.319C65.8868 120.319 67.5348 121.973 67.5348 124.017Z",
    stroke: "#E1E4E5",
    strokeWidth: 1.849,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M205.439 31.1697C200.267 35.4963 200.573 44.3857 200.573 44.3857C200.573 44.3857 209.264 46.2547 214.433 41.9233C219.604 37.5967 219.301 28.712 219.301 28.712C219.301 28.712 210.61 26.843 205.439 31.1697V31.1697Z",
    fill: "url(#paint1_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.763 46.971C113.261 48.8459 114.424 50.7867 116.362 51.3059C118.299 51.8251 120.277 50.726 120.78 48.851C121.282 46.9761 120.119 45.0352 118.181 44.5161C116.243 43.9969 114.265 45.096 113.763 46.971Z",
    fill: "#E1E4E5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M248.083 95.3744C247.209 98.6382 243.854 100.575 240.59 99.7005C237.327 98.826 235.39 95.4713 236.264 92.2075C237.139 88.9438 240.493 87.0069 243.757 87.8814C247.021 88.7559 248.958 92.1107 248.083 95.3744Z",
    fill: "#A9162A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M196.483 59.1509C196.158 60.3649 195.089 61.1332 194.095 60.8671C193.102 60.6009 192.561 59.401 192.886 58.187C193.211 56.973 194.28 56.2047 195.273 56.4708C196.267 56.737 196.808 57.9369 196.483 59.1509Z",
    fill: "#E1E4E5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7671 52.277H83.8424C84.2878 58.1953 88.9827 58.2863 88.9827 58.2863C88.9827 58.2863 83.8057 58.3813 83.8057 65.2196C83.8057 58.3813 78.6284 58.2863 78.6284 58.2863C78.6284 58.2863 83.3214 58.1953 83.7671 52.277ZM220.226 49.9723H220.29C220.672 54.707 224.696 54.78 224.696 54.78C224.696 54.78 220.259 54.856 220.259 60.3266C220.259 54.856 215.821 54.78 215.821 54.78C215.821 54.78 219.844 54.707 220.226 49.9723V49.9723Z",
    fill: "#E1E4E5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.146 152.269L97.2997 161.115C96.9775 161.437 96.9774 161.96 97.2996 162.282C97.6217 162.604 98.144 162.604 98.4662 162.282L107.312 153.436C107.634 153.113 107.635 152.591 107.312 152.269C106.99 151.947 106.468 151.947 106.146 152.269Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.385 152.269L104.539 161.115C104.217 161.437 104.216 161.96 104.539 162.282C104.861 162.604 105.383 162.604 105.705 162.282L114.551 153.436C114.874 153.113 114.874 152.591 114.551 152.269C114.229 151.947 113.707 151.947 113.385 152.269Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M121.076 152.269L112.23 161.115C111.907 161.437 111.907 161.96 112.229 162.282C112.552 162.604 113.074 162.604 113.396 162.282L122.242 153.436C122.564 153.113 122.564 152.591 122.242 152.269C121.92 151.947 121.398 151.947 121.076 152.269Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M189.331 164.111C192.803 164.115 197.799 163.211 201.892 159.266C205.985 155.32 203.684 152.869 199.621 152.424C195.558 151.98 190.686 153.833 187.531 157.801C184.376 161.769 186.481 164.107 189.331 164.111V164.111Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 145.786,
    y1: -32.0976,
    x2: 148.516,
    y2: 277.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 187.558,
    y1: 48.6527,
    x2: 243.667,
    y2: 18.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 207.683,
    y1: 165.409,
    x2: 176.096,
    y2: 147.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/EmailSent.fb0beb0a1bba42ae2eccf481557f6ffc.svg";
export { ForwardRef as ReactComponent };